/**
 * Formatting constants shared across the module.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md §4.3
 */

/**
 * The locale every number is formatted in, regardless of interface language.
 *
 * PRD §9.5 requires comma thousands and full-stop decimals **in every
 * language**. Inheriting the browser locale would render `1.234,56` for a
 * Portuguese user and quietly change what the figure means. `en-GB` is the
 * locale whose separators match the specification; the interface language is a
 * separate concern entirely.
 */
export const NUMERIC_LOCALE = 'en-GB';

/** True minus sign, U+2212 — not the hyphen-minus a keyboard produces. */
export const MINUS = '−';

/** En dash, U+2013, for ranges. */
export const EN_DASH = '–';

/** Non-breaking space: a unit must never wrap away from its number. */
export const NBSP = ' ';

/** Significant figures permitted by PRD §9.5. */
export const SIGNIFICANT_FIGURES = {
  /** Dense contexts — a table column the reader scans vertically. */
  table: 3,
  /** A single large figure the reader is meant to remember. */
  headline: 2,
} as const;

export type Precision = keyof typeof SIGNIFICANT_FIGURES;
